"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringToSnakeCase = exports.getDeployableInfo = exports.getCookie = exports.convertCamelCaseToSnakeCase = exports.camelToSnakeCase = void 0;

require("core-js/modules/es6.regexp.split.js");

require("core-js/modules/es6.regexp.replace.js");

require("core-js/modules/es6.object.keys.js");

var _universalCookie = _interopRequireDefault(require("universal-cookie"));

var _appConfig = _interopRequireDefault(require("@nerdwallet/app-config"));

var cookies = new _universalCookie.default();

var getCookie = function getCookie(cookieName) {
  return cookies.get(cookieName);
}; // Utility function to convert strings to snake case.
// Empty, null or undefined inputs return an empty string.


exports.getCookie = getCookie;

var stringToSnakeCase = function stringToSnakeCase(str) {
  if (str) {
    return str.toLowerCase().replace(/\W+/g, ' ').split(/ |\B(?=[A-Z])/).join('_');
  }

  return '';
};

exports.stringToSnakeCase = stringToSnakeCase;

var camelToSnakeCase = function camelToSnakeCase(str) {
  return str.replace(/[A-Z]/g, function (letter) {
    return "_".concat(letter.toLowerCase());
  });
}; // Utility function to convert object properties
// from camel case to snake case


exports.camelToSnakeCase = camelToSnakeCase;

var convertCamelCaseToSnakeCase = function convertCamelCaseToSnakeCase(obj) {
  if (!obj) return obj;
  var snakeCasedObject = {};
  Object.keys(obj).forEach(function (prop) {
    snakeCasedObject[camelToSnakeCase(prop)] = obj[prop];
  });
  return snakeCasedObject;
};

exports.convertCamelCaseToSnakeCase = convertCamelCaseToSnakeCase;

var getDeployableInfo = function getDeployableInfo() {
  var _config$_meta, _config$_meta2;

  return {
    // eslint-disable-next-line no-underscore-dangle
    deployable_name: _appConfig.default === null || _appConfig.default === void 0 ? void 0 : (_config$_meta = _appConfig.default._meta) === null || _config$_meta === void 0 ? void 0 : _config$_meta.deployable,
    // eslint-disable-next-line no-underscore-dangle
    deployable_version: _appConfig.default === null || _appConfig.default === void 0 ? void 0 : (_config$_meta2 = _appConfig.default._meta) === null || _config$_meta2 === void 0 ? void 0 : _config$_meta2.version
  };
};

exports.getDeployableInfo = getDeployableInfo;